import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28cdf473"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid g-0 efj__dynamicform" }
const _hoisted_2 = {
  key: 0,
  class: "row error-style"
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "row text-start align-items-top mt-2 form-group"
}
const _hoisted_6 = {
  key: 0,
  class: "col-12 efj__filter"
}
const _hoisted_7 = { class: "efj__filterIcon--Text" }
const _hoisted_8 = {
  key: 1,
  class: "col-1"
}
const _hoisted_9 = ["id", "disabled", "onUpdate:modelValue"]
const _hoisted_10 = {
  key: 2,
  class: "col-11"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 3,
  class: "col-1"
}
const _hoisted_16 = ["id", "disabled", "onUpdate:modelValue"]
const _hoisted_17 = {
  key: 4,
  class: "col-11"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 5,
  class: "col-12 no-gutters"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gap" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 6,
  class: "row text-left align-items-top mt-2 me-2 form-group col-12 no-gutters"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "efj__refreshIcon--Text" }
const _hoisted_30 = {
  key: 7,
  class: "row text-left align-items-top mt-2 me-2 form-group col-12 no-gutters"
}
const _hoisted_31 = { class: "validation-text-error" }
const _hoisted_32 = {
  key: 8,
  class: "col-12"
}
const _hoisted_33 = { class: "validation-text-error" }
const _hoisted_34 = ["id", "disabled", "onUpdate:modelValue"]
const _hoisted_35 = {
  key: 9,
  class: "col-2"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 10,
  class: "col-8"
}
const _hoisted_38 = {
  key: 11,
  class: "col-2"
}
const _hoisted_39 = {
  key: 12,
  class: "col-1"
}
const _hoisted_40 = ["id", "disabled", "onUpdate:modelValue"]
const _hoisted_41 = {
  key: 13,
  class: "col-11"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  key: 14,
  class: "col-12"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_48 = {
  key: 15,
  class: "col-12"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_52 = {
  key: 16,
  class: "col-12"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_56 = {
  key: 17,
  class: "col-12"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_60 = {
  key: 18,
  class: "col-12"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = {
  key: 1,
  class: "validation-text-error infoIcon__same-row"
}
const _hoisted_64 = {
  key: 3,
  class: "efj__info"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 19,
  class: "col-12"
}
const _hoisted_67 = {
  key: 20,
  class: "col-12"
}
const _hoisted_68 = {
  key: 21,
  class: "col-12"
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = { style: {"display":"inline-block","min-width":"Calc(100% - 30px)"} }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["id", "name", "disabled", "onUpdate:modelValue"]
const _hoisted_74 = {
  key: 22,
  class: "col-12"
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_78 = {
  key: 23,
  class: "col-12"
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_82 = ["id", "name", "disabled", "onUpdate:modelValue"]
const _hoisted_83 = {
  key: 24,
  class: "col-12"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_87 = { class: "form-label-group input-group" }
const _hoisted_88 = { class: "login__container--password" }
const _hoisted_89 = ["type", "id", "disabled", "onUpdate:modelValue"]
const _hoisted_90 = ["src"]
const _hoisted_91 = {
  key: 25,
  class: "col-12"
}
const _hoisted_92 = { key: 0 }
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = {
  key: 1,
  class: "validation-text-error"
}
const _hoisted_95 = {
  key: 3,
  class: "form-label-group input-group"
}
const _hoisted_96 = { class: "login__container--password" }
const _hoisted_97 = ["type", "id", "disabled", "onUpdate:modelValue"]
const _hoisted_98 = ["src"]
const _hoisted_99 = {
  key: 26,
  class: "row text-left align-items-top ms-1 mt-2 me-1 form-group col-2 no-gutters"
}
const _hoisted_100 = { key: 0 }
const _hoisted_101 = ["onUpdate:modelValue"]
const _hoisted_102 = {
  key: 1,
  class: "form__filter"
}
const _hoisted_103 = ["onClick"]
const _hoisted_104 = {
  key: 27,
  class: "row text-left align-items-top ms-1 mt-2 me-1 form-group col-12 no-gutters action_button"
}
const _hoisted_105 = { key: 0 }
const _hoisted_106 = ["onUpdate:modelValue"]
const _hoisted_107 = ["onClick", "disabled"]
const _hoisted_108 = {
  key: 28,
  class: "row text-left align-items-top ms-1 mt-2 me-1 form-group col-12 no-gutters"
}
const _hoisted_109 = { key: 0 }
const _hoisted_110 = ["onUpdate:modelValue"]
const _hoisted_111 = {
  type: "submit",
  class: "btn action__button_primary btn-block"
}
const _hoisted_112 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoDataRender = _resolveComponent("NoDataRender")!
  const _component_ComboBox = _resolveComponent("ComboBox")!
  const _component_GeoMap = _resolveComponent("GeoMap")!
  const _component_WarenKorbListe = _resolveComponent("WarenKorbListe")!
  const _component_vue_datepicker = _resolveComponent("vue-datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getScrollPage())
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.result.view, (row, id) => {
            return (_openBlock(), _createElementBlock("div", { key: id }, [
              (row.istSichtbar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (row.feldTyp === 'ResetFilter' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("img", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resetFilterValues()), ["prevent"])),
                            class: "efj__filterIcon",
                            src: "img/icons/refresh.svg",
                            alt: "Filter zurücksetzen"
                          }),
                          _createElementVNode("p", _hoisted_7, _toDisplayString(row.feldTitel), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'CheckTextRight' && row.istSichtbar && _ctx.lowerCaseTextBoolean(row))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass({ 'validation-error': row.isValidationError }),
                            type: "checkbox",
                            id: row.formularFeldname,
                            disabled: !row.istEditierbar,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                          }, null, 10, _hoisted_9), [
                            [_vModelCheckbox, row.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'CheckTextRight' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control design__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_12), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: row.feldTitel,
                                class: "validation-text-error"
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                innerHTML: row.feldTitel,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, null, 10, _hoisted_14))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'CheckTextRightFix' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass({ 'validation-error': row.isValidationError }),
                            type: "checkbox",
                            id: row.formularFeldname,
                            disabled: !row.istEditierbar,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                          }, null, 10, _hoisted_16), [
                            [_vModelCheckbox, row.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'CheckTextRightFix' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control design__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_19), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: row.feldTitel,
                                class: "validation-text-error"
                              }, null, 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                innerHTML: row.feldTitel,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, null, 10, _hoisted_21))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Space' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Label' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_27), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !_ctx.contains(row, 'gps'))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.getLayoutClass(row))
                              }, [
                                _createElementVNode("div", {
                                  innerHTML: row.feldTitel
                                }, null, 8, _hoisted_28)
                              ], 2))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && _ctx.contains(row, 'gps'))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(_ctx.getLayoutClass(row))
                              }, [
                                _createElementVNode("p", _hoisted_29, _toDisplayString(row.feldTitel), 1),
                                _createElementVNode("img", {
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getGpsSignal()), ["prevent"])),
                                  class: "efj__refreshIcon",
                                  src: "img/icons/gps.png",
                                  alt: "GPS"
                                })
                              ], 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Paragraph' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(row.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Check' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          (row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass({ 'text-danger': row.isValidationError })
                              }, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 1)
                              ], 2))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass({ 'validation-error': row.isValidationError }),
                            type: "checkbox",
                            id: row.formularFeldname,
                            disabled: !row.istEditierbar,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                          }, null, 10, _hoisted_34), [
                            [_vModelCheckbox, row.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Icon' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("img", {
                            class: "efj__filterIcon",
                            src: row.value
                          }, null, 8, _hoisted_36)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Icon' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.contentText), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Icon' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.additionalText), 1))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ValueCheck' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass({ 'validation-error': row.isValidationError }),
                            type: "checkbox",
                            id: row.formularFeldname,
                            disabled: !row.istEditierbar,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                          }, null, 10, _hoisted_40), [
                            [_vModelCheckbox, row.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ValueCheck' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          (!row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: row.resourceId,
                                class: "validation-text-error"
                              }, null, 8, _hoisted_42))
                            : _createCommentVNode("", true),
                          (row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: row.resourceId,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, null, 10, _hoisted_43))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'RemoteComboBox' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_46), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (_openBlock(), _createBlock(_component_ComboBox, {
                            key: _ctx.updateCombobox,
                            id: row.formularFeldname,
                            style: { width: '100%' },
                            "data-items": row.namedValueList,
                            "text-field": 'value',
                            "data-item-key": 'key',
                            "allow-custom": true,
                            "list-no-data-render": _ctx.listNoDataRender,
                            value: _ctx.getKeyValuePair(row),
                            disabled: !row.istEditierbar,
                            size: "small",
                            onChange: _ctx.remoteComboSelectedChange
                          }, {
                            NoDataRender: _withCtx(({}) => [
                              _createVNode(_component_NoDataRender)
                            ]),
                            _: 2
                          }, 1032, ["id", "data-items", "list-no-data-render", "value", "disabled", "onChange"]))
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ComboBox' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_50), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (_openBlock(), _createBlock(_component_ComboBox, {
                            key: _ctx.updateCombobox,
                            id: row.namedValueListDataSourceName,
                            style: { width: '100%' },
                            "data-items": row.namedValueList,
                            "text-field": 'value',
                            "data-item-key": 'key',
                            "allow-custom": true,
                            filterable: true,
                            "list-no-data-render": _ctx.listNoDataRender,
                            value: _ctx.getKeyValuePair(row),
                            disabled: !row.istEditierbar,
                            size: "small",
                            onOpen: _ctx.onOpenComboBox,
                            onClose: _ctx.onCloseComboBox,
                            onChange: _ctx.comboSelectedChange,
                            onFilterchange: _ctx.filterChanged
                          }, {
                            NoDataRender: _withCtx(({}) => [
                              _createVNode(_component_NoDataRender)
                            ]),
                            _: 2
                          }, 1032, ["id", "data-items", "list-no-data-render", "value", "disabled", "onOpen", "onClose", "onChange", "onFilterchange"]))
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ComboBoxDisplayValue' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_54), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ComboBox, {
                            id: row.namedValueListDataSourceName,
                            style: { width: '100%' },
                            "data-items": row.namedValueList,
                            "text-field": 'value',
                            "data-item-key": 'value',
                            "allow-custom": true,
                            filterable: true,
                            "value-field": 'value',
                            "value-primitive": true,
                            "list-no-data-render": _ctx.listNoDataRender,
                            placeholder: '',
                            disabled: !row.istEditierbar,
                            modelValue: row.value,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                            size: "small",
                            onFilterchange: _ctx.filterChanged
                          }, {
                            NoDataRender: _withCtx(({}) => [
                              _createVNode(_component_NoDataRender)
                            ]),
                            _: 2
                          }, 1032, ["id", "data-items", "list-no-data-render", "disabled", "modelValue", "onUpdate:modelValue", "onFilterchange"])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'OnlineComboBox' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_58), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ComboBox, {
                            id: row.namedValueListDataSourceName,
                            style: { width: '100%' },
                            "data-items": row.list,
                            "allow-custom": true,
                            filterable: true,
                            "list-no-data-render": _ctx.listNoDataRender,
                            disabled: !row.istEditierbar || _ctx.blocked.value,
                            modelValue: row.value,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                            onChange: _ctx.onlineSelectionChanged,
                            onFilterchange: _ctx.onlineFilterChanged,
                            size: "small"
                          }, {
                            NoDataRender: _withCtx(({}) => [
                              _createVNode(_component_NoDataRender)
                            ]),
                            _: 2
                          }, 1032, ["id", "data-items", "list-no-data-render", "disabled", "modelValue", "onUpdate:modelValue", "onChange", "onFilterchange"])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ObjectComboBox' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_62), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error infoIcon__same-row", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (_ctx.isInformationVisible(row.infoTextTitle,row.infoTextContent))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (_ctx.openInformation(row.infoTextTitle,row.infoTextContent)),
                                  class: "efj__infoIcon",
                                  src: "img/icons/info_label.svg",
                                  alt: "Information"
                                }, null, 8, _hoisted_65)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ComboBox, {
                            id: row.namedValueListDataSourceName,
                            style: { width: '100%' },
                            "data-items": row.list,
                            "allow-custom": false,
                            filterable: true,
                            "text-field": 'value',
                            "list-no-data-render": _ctx.listNoDataRender,
                            disabled: !row.istEditierbar,
                            modelValue: row.value,
                            "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                            onChange: _ctx.selectObjectListSelectionChanged,
                            onFilterchange: _ctx.selectObjectListFilterChanged,
                            onOpen: _ctx.openSelectionBox,
                            onClose: _ctx.closeSelectionBox,
                            size: "small"
                          }, {
                            NoDataRender: _withCtx(({}) => [
                              _createVNode(_component_NoDataRender)
                            ]),
                            _: 2
                          }, 1032, ["id", "data-items", "list-no-data-render", "disabled", "modelValue", "onUpdate:modelValue", "onChange", "onFilterchange", "onOpen", "onClose"])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Karte' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _createVNode(_component_GeoMap, _normalizeProps(_guardReactiveProps(_ctx.geoRequest)), null, 16)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'WarenKorb' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createVNode(_component_WarenKorbListe)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Text' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_70), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["validation-text-error", _ctx.serverValidation(row)])
                              }, [
                                _createElementVNode("div", _hoisted_71, _toDisplayString(row.feldTitel), 1),
                                (_ctx.isInformationVisible(row.infoTextTitle,row.infoTextContent))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.openInformation(row.infoTextTitle,row.infoTextContent)),
                                      class: "efj__infoIcon",
                                      style: {"display":"inline-block"},
                                      src: "img/icons/info_label.svg",
                                      alt: "Information"
                                    }, null, 8, _hoisted_72))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode())
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 3,
                                type: "text",
                                id: row.formularFeldname,
                                name: row.formularFeldname,
                                disabled: !row.istEditierbar,
                                class: "form-control",
                                spellcheck: "false",
                                autocorrect: "off",
                                autocapitalize: "off",
                                autocomplete: "xxxyzzz",
                                "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                              }, null, 8, _hoisted_73)), [
                                [_vModelText, row.value]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Date' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_76), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode())
                            ? (_openBlock(), _createBlock(_component_vue_datepicker, {
                                key: 3,
                                id: row.formularFeldname,
                                disabled: !row.istEditierbar,
                                teleport: true,
                                lang: _ctx.clientSettings.language,
                                locale: _ctx.clientSettings.language,
                                modelValue: row.dateValue,
                                "onUpdate:modelValue": ($event: any) => ((row.dateValue) = $event),
                                format: 'dd.MM.yyyy',
                                clearable: true,
                                "select-text": _ctx.clientSettings.okText,
                                "cancel-Text": _ctx.clientSettings.cancelText,
                                "text-input": ""
                              }, null, 8, ["id", "disabled", "lang", "locale", "modelValue", "onUpdate:modelValue", "format", "select-text", "cancel-Text"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp.toLowerCase() === 'email' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_80), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode())
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 3,
                                class: _normalizeClass([{ 'validation-error': row.isValidationError }, "form-control"]),
                                type: "email",
                                id: row.formularFeldname,
                                name: row.formularFeldname,
                                disabled: !row.istEditierbar,
                                spellcheck: "false",
                                autocorrect: "off",
                                autocapitalize: "off",
                                autocomplete: "xxxyzzz",
                                "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                              }, null, 10, _hoisted_82)), [
                                [_vModelText, row.value]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'Password' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_85), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              (!_ctx.getDesignMode())
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    class: _normalizeClass([{ 'validation-error': row.isValidationError }, "form-control login__input--password"]),
                                    type: _ctx.passwordType,
                                    id: row.formularFeldname,
                                    disabled: !row.istEditierbar,
                                    spellcheck: "false",
                                    autocorrect: "off",
                                    autocapitalize: "off",
                                    autocomplete: "new-password",
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                                  }, null, 10, _hoisted_89)), [
                                    [_vModelDynamic, row.value]
                                  ])
                                : _createCommentVNode("", true),
                              (!_ctx.getDesignMode())
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                                    class: "password-image"
                                  }, [
                                    _createElementVNode("img", {
                                      class: "password-image",
                                      src: _ctx.passwortIcon,
                                      alt: "Hidden",
                                      width: "50",
                                      height: "32"
                                    }, null, 8, _hoisted_90)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'PasswordValidation' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_93), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && !row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(row.feldTitel), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode() && row.isValidationError)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["validation-text-error", { 'text-danger': row.isValidationError }])
                              }, _toDisplayString(row.feldTitel) + " - " + _toDisplayString(row.validationMessage ?? "ungültige Eingabe"), 3))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass([{ 'validation-error': row.isValidationError }, "form-control login__input--password"]),
                                    type: _ctx.passwordValidationType,
                                    id: row.formularFeldname,
                                    disabled: !row.istEditierbar,
                                    spellcheck: "false",
                                    autocorrect: "off",
                                    autocapitalize: "off",
                                    autocomplete: "new-password",
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                                  }, null, 10, _hoisted_97), [
                                    [_vModelDynamic, row.value]
                                  ]),
                                  _createElementVNode("div", {
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordValidation && _ctx.togglePasswordValidation(...args))),
                                    class: "password-image"
                                  }, [
                                    _createElementVNode("img", {
                                      class: "password-image",
                                      src: _ctx.passwortValidationIcon,
                                      alt: "Hidden",
                                      width: "50",
                                      height: "32"
                                    }, null, 8, _hoisted_98)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ActionFilter' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_101), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                _createElementVNode("img", {
                                  onClick: _withModifiers(($event: any) => (_ctx.action(row)), ["prevent"]),
                                  src: "img/icons/filter.svg",
                                  class: "form__filter--symbol"
                                }, null, 8, _hoisted_103)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'ActionButton' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_106), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.action(row)), ["prevent"]),
                              class: _normalizeClass(row.layoutKlasse),
                              disabled: _ctx.disabledActionButton
                            }, _toDisplayString(row.feldTitel), 11, _hoisted_107)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (row.feldTyp === 'SubmitButton' && row.istSichtbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          (_ctx.getDesignMode())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                _createTextVNode(_toDisplayString(row.resourceId) + "    ", 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control desing__control",
                                  autocapitalize: "off",
                                  "onUpdate:modelValue": ($event: any) => ((row.feldTitel) = $event)
                                }, null, 8, _hoisted_110), [
                                  [_vModelText, row.feldTitel]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(row.layoutKlasse)
                          }, [
                            _createElementVNode("button", _hoisted_111, _toDisplayString(row.feldTitel), 1)
                          ], 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.getDesignMode())
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.saveResources()), ["prevent"])),
                  class: "btn action__button_primary btn-block"
                }, "Save ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}